<template>
  <div class="industry">
    <div class="header">
      <p>Make good water for health</p>
      <div class="p">Make good water for health</div>
    </div>
    <!-- 菜单 -->
    <div class="industry-menu">
      <div class="menu-head">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>Industry</el-breadcrumb-item>
          <el-breadcrumb-item>{{BreadText}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="gundong">
        <ul class="menu-content">
          <li v-for="item in industryMenu" :key="item.id" :class="inRouter == item.name?'innovate-gl':''">
            <router-link :to="{name:item.name}">{{item.text}}
            </router-link>
          </li>
        </ul>
      </div>
    </div>
    <!-- 路由内容 -->
    <transition enter-active-class="animate__animated animate__fadeIn">
      <router-view />
    </transition>
    <!-- 联系我们 -->
    <div class="footer animate__animated wow animate__fadeIn">
      <div class="title">About Us</div>
      <div class="content">
        <div class="content-box flex2">
          <div class="box-top"><i class="el-icon-location"></i>Address</div>
          <div class="box-main">
            <div class="left">Office address: &nbsp;</div>
            <div class="right"> Room 704, block B, Jiatai building, No. 41, East Fourth Ring Middle Road, Chaoyang District, Beijing</div>
          </div>
          <div class="box-main">
            <div class="left">actory address: &nbsp;</div>
            <div class="right">5th Floor, Building 12, BioPort, No. 52 Yingang Road, Fuqiao Town, Taicang City, Suzhou Province</div>
          </div>
        </div>
        <div class="content-box">
          <div class="box-top"><i class="el-icon-location"></i>Contact</div>
          <div class="box-main">
            <div class="left">Emai：</div>
            <div class="right">kdw@kdw.com.cn</div>
          </div>
          <div class="box-main">
            <div class="left">lPostal code：</div>
            <div class="right">100023</div>
          </div>
          <div class="box-main">
            <div class="left">Fax：</div>
            <div class="right">010-67207401</div>
          </div>
        </div>
        <div class="content-box">
          <div class="box-top"><i class="el-icon-phone"></i>Telephone</div>
          <div class="box-main">
            <div class="left">Kang De WeiBusiness department</div>
            <!-- <div class="right">北京市朝阳区东四环中路41号嘉 泰大厦B座704室</div> -->
          </div>
          <div class="box-main">
            <div class="left">phone：</div>
            <div class="right">010-67207401</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import WOW from "../../../node_modules/wowjs/dist/wow";
export default {
  data() {
    return {
      industryMenu: [
        {
          id: 1,
          text: 'Kangdewei',
          name: 'kaineng'
        },
        {
          id: 2,
          text: 'Hemodialysis Water Treatment Equipment',
          name: 'water'
        },
        {
          id: 3,
          text: 'Dialysis Centralized Liquid Supply System',
          name: 'jizhong'
        }
      ],
      inRouter: this.$router.history.current.name,
      BreadText: this.$router.history.current.meta.title || ''
    }
  },
  watch: {
    $route(to) {
      let newpath = to.path.slice(1).split('/')[1]
      this.inRouter = newpath
      let MybreadText = this.industryMenu.filter(item => {
        return item.name == newpath
      })
      this.BreadText = MybreadText[0].text
    }
  },
  created() {

  },
  mounted() {
    // let wow = new WOW.WOW({
    //   boxClass: "wow",
    //   animateClass: "animated",
    //   offset: 0,
    //   mobile: true,
    //   live: true
    // });
    // wow.init();
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
.industry {
  .header {
    height: 5.2632rem;
    width: 100%;
    background: url('../../assets/image/Industry/big-bg.webp') no-repeat;
    background-size: 100% 100%;
    @media screen and (max-width: 540px) {
      height: 250px;
      background-size: cover;
      background-position: 77% 0;
      display: flex;
      justify-content: center;
    }
    p {
      color: #333;
      font-size: 0.4211rem;
      font-weight: 600;
      padding: 2.6316rem 0 0 2.9579rem;
      @media screen and (max-width: 540px) {
        display: none;
      }
    }
    .p {
      display: none;
      @media screen and (max-width: 540px) {
        display: block;
        color: #555555;
        font-size: 22px;
        padding-top: 10px;
        line-height: 40px;
      }
    }
  }
  // 头部菜单
  .industry-menu {
    height: 1.1789rem;
    margin: 0 0.8421rem;
    position: relative;
    display: flex;
    justify-content: space-between;
    // justify-content: center;
    padding: 0 0.2316rem;
    align-items: center;
    @media screen and (max-width: 540px) {
      margin: 0;
      height: 56px;
    }
    .menu-head {
      padding-right: 1.6316rem;
      width: 3.6316rem;
      font-size: 0.2105rem !important;
      @media screen and (max-width: 540px) {
        display: none;
      }
      .el-breadcrumb {
        font-size: 0.1895rem;
      }
    }
    .gundong::-webkit-scrollbar {
      display: none;
    }
    .gundong {
      height: 100%;
      @media screen and (max-width: 540px) {
        overflow: scroll;
        overflow-y: hidden;
      }
      .menu-content {
        display: flex;
        height: 100%;
        li {
          display: flex;
          align-items: center;
          height: 100%;
          padding: 0 0.4737rem;
          font-size: 0.2105rem;
          box-sizing: border-box;
          border-bottom: 6px solid #0ca4eb00;
          @media screen and (max-width: 540px) {
            font-size: 15px;
            margin: 0 15px;
          }
          a {
            font-weight: 700;
            list-style: none;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            color: #666666;
          }
        }
      }
    }
  }
  .industry-menu::after {
    position: absolute;
    content: '';
    bottom: 0;
    left: 0;
    height: 6px;
    width: 100%;
    border-radius: 0.0316rem;
    background-color: #f1f1f1;
  }
  // 菜单高亮
  .innovate-gl {
    a {
      color: #0ca6eb !important;
    }
    // padding: 0.4737rem 0 0.3789rem 0;
    border-bottom-color: #0ca6eb !important;
    z-index: 999;
  }
  // 底部联系我们
  .footer {
    height: 5.3895rem;
    width: 100%;
    background: url('../../assets/image/Industry/footer-bg.webp') no-repeat;
    background-size: 100% 100%;
    padding: 0 2rem;
    box-sizing: border-box;
    @media screen and (max-width: 540px) {
      height: 448px;
      padding: 20px;
      background-size: inherit;
    }
    .title {
      padding: 0.8632rem 0 0.8211rem 0;
      font-size: 0.3579rem;
      color: #fff;
      position: relative;
      font-weight: 700;
      text-align: left;
      @media screen and (max-width: 540px) {
        font-size: 19px;
      }
    }
    .title::after {
      position: absolute;
      content: '';
      height: 0.0632rem;
      width: 0.3263rem;
      bottom: 0.5789rem;
      background-color: #fff;
      left: 0;
      @media screen and (max-width: 540px) {
        width: 16px;
        height: 3px;
      }
    }
    .content {
      display: flex;
      @media screen and (max-width: 540px) {
        display: block;
      }
      .flex2{
        flex: 2 !important;
      }
      .content-box {
        flex: 1;
        padding-right: 0.8421rem;
        @media screen and (max-width: 540px) {
          padding-bottom: 20px;
        }
        .box-top {
          font-size: 0.2526rem;
          color: #fff;
          padding-bottom: 0.2947rem;
          @media screen and (max-width: 540px) {
            // padding-bottom: 23px;
            font-size: 15px;
          }
          i {
            padding-right: 0.1053rem;
          }
        }
        .box-main {
          display: flex;
          padding-bottom: 0.2947rem;
          font-size: 0.2105rem;
          color: #fff;
          @media screen and (max-width: 540px) {
            font-size: 13px;
          }
          .right {
            flex: 1;
          }
        }
      }
    }
  }
}
</style>
